import styled from 'styled-components';
import { color, typography } from 'styles/settings';
import { BackButton as _BackButton } from 'routes/surface/components/node-modal-form/components/document-node-modal/components/document-node-form/style';
import { withModifiers } from 'utils';
import SimpleBar from 'simplebar-react';

export const ScrollableContainer = styled(SimpleBar)`
  overflow-x: hidden;
  height: 100%;
  max-height: calc(100vh - 177px);
`;

export const BackButton = styled(_BackButton)`
  & {
    display: block;
    font-size: ${typography.size.md};
  }
`;

export const Header = styled.div`
  width: 100%;
  height: 177px;
  background-color: ${color.neutral.grayPaler};
  box-shadow: 0 0 5px rgba(28, 27, 24, 0.6);
  box-sizing: border-box;
  position: relative;
  padding: 55px 0 0 55px;
`;

export const LinkCounter = styled.div`
  margin: 50px 40px 25px 0;
  font-size: ${typography.size.lg};
  color: ${color.brand.blue};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  span {
    margin-left: 10px;
  }
`;

export const LinkCounterLabel = styled.span`
  color: ${color.neutral.plainBlack};
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  padding: 0 40px;
  font-size: ${typography.size.md};
  color: ${color.neutral.plainBlack};
  height: 100%;
`;

export const Name = styled.span`
  color: ${color.brand.blue};
`;

export const Container = styled.div`
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  background-color: ${color.neutral.white};
  width: 0;
  transition: width 0.2s;
`;

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background-color: black;
  transition: opacity 0.2s;
  opacity: 0;
`;

export const Wrapper = styled.div`
  ${typography.font.semiBold};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;

  ${withModifiers('isVisible')`
        ${Overlay} {
            opacity: 0.6;
        }

        ${Container} {
            width: 675px;
        }
    `}
`;
